'use client';

import { useTranslations } from 'next-intl';

export function LegalOriginOfMoneyDetailsView() {
    const t = useTranslations();

    return (
        <ul className="list-inside space-y-2">
            {t.rich('eshop.life.legalOriginOfMoneyDetails', {
                li: children => (
                    <li>
                        <span className="mr-2 inline-block size-2 flex-shrink-0 rounded-full bg-primary-500" />
                        {children}
                    </li>
                ),
            })}
        </ul>
    );
}
